import { WaterlilyClient } from '@/api/waterlily';
import {
  LicensesResponse,
  CreateLicenseRequest,
  UpdateLicenseRequest,
  License,
  SetActiveLicenseRequest,
} from '@/features/licenses/types';

export const licensesApi = {
  getLicenses: async (advisorId: string): Promise<LicensesResponse> => {
    return await WaterlilyClient.get<LicensesResponse>(`/licenses/${advisorId}`);
  },

  createLicense: async (
    advisorId: string,
    data: CreateLicenseRequest,
  ): Promise<{ license: License }> => {
    return await WaterlilyClient.post<{ license: License }>(`/license/${advisorId}`, data);
  },

  updateLicense: async (
    advisorId: string,
    licenseId: string,
    data: UpdateLicenseRequest,
  ): Promise<{ license: License }> => {
    return await WaterlilyClient.put<{ license: License }>(
      `/license/${advisorId}/${licenseId}`,
      data,
    );
  },

  deleteLicense: async (
    advisorId: string,
    licenseId: string,
  ): Promise<{ success: boolean; switchedToAdvisorLicense: boolean }> => {
    return await WaterlilyClient.delete<{ success: boolean; switchedToAdvisorLicense: boolean }>(
      `/license/${advisorId}/${licenseId}`,
    );
  },

  setActiveLicense: async (
    advisorId: string,
    data: SetActiveLicenseRequest,
  ): Promise<{ success: boolean; activeLicenseId: string }> => {
    return await WaterlilyClient.put<{ success: boolean; activeLicenseId: string }>(
      `/active-illustration-license/${advisorId}`,
      data,
    );
  },
};
